export type PaginationParams = {
    limit: number
    offset: number
}

export enum SortingDirection {
    NONE = 'none',
    ASCENDING = 'asc',
    DESCENDING = 'desc',
}

export interface SortingParams {
    sortBy: string
    direction: SortingDirection
}
